/**
 * Spanish labels for Allexpress order status codes.
 * Used in ticket list, chat header chip, and order details dialog.
 */
export const ORDER_STATUS_ES = {
	CREATED: "Orden creada",
	ASSIGNED: "Motorizado asignado",
	STARTED: "Motorizado en camino",
	AT_PICKUP: "Llegó al punto de recogida",
	PICKED_UP: "Paquete recogido",
	EN_ROUTE: "En camino a destino",
	AT_DELIVERY: "Llegó al destino",
	DELIVERED: "Paquete entregado",
	COMPLETED: "Orden completada",
	CANCELLED: "Cancelada",
};

/**
 * @param {string} statusCode - e.g. 'STARTED', 'COMPLETED'
 * @returns {string} Spanish label or the code if unknown
 */
export function getOrderStatusLabel(statusCode) {
	if (!statusCode) return "";
	return ORDER_STATUS_ES[statusCode] || statusCode;
}

/**
 * @param {{ status: 'active'|'finalized'|null, order?: { currentStatus: string }, label?: string }} orderStatus
 * @returns {string} Full label for chip display
 */
export function getOrderStatusChipLabel(orderStatus) {
	if (!orderStatus?.label) return "";
	if (orderStatus.status === "finalized") return "Orden finalizada";
	if (orderStatus.status === "active" && orderStatus.order?.currentStatus) {
		return `Orden en curso (${getOrderStatusLabel(orderStatus.order.currentStatus)})`;
	}
	return orderStatus.label;
}
